(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("lazy-load", [], factory);
	else if(typeof exports === 'object')
		exports["lazy-load"] = factory();
	else
		root["lazy-load"] = factory();
})(this, function() {
return 